import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const confirmAnnualClientActivity = async (clientId, isActive) => {
    try {
        const token = Cookies.get("Bearer");
        const response = await axios.post(
            `${FIRMFLOWURL}api/Client/${clientId}/annual-review/confirm-active`,
            { isActive },
            { headers: { Authorization: token } },
        );

        return { ...response, success: true };
    } catch (error) {
        if (error?.response?.status === 401) {
            Cookies.remove("Bearer");
            window.location.replace("/");
            return { success: false, status: 401 };
        }

        return {
            success: false,
            status: error?.response?.status,
            data: error?.response?.data,
            message:
                error?.response?.data?.message ||
                error?.message ||
                "The Semiannual Client Review could not be started.",
        };
    }
};
